/* ============================================================
   Chronic — Purchase Options Widget script — 10% OFF VARIANT (progressive enhancement)

   GUARANTEE MODEL:
   - The native Shopify Add to cart is the bedrock and stays visible.
   - This script only HIDES the native button (and reveals the widget) after
     it has successfully initialised, by adding `cpo10-js-ready` to <body>.
   - If this file fails to load or throws at any point, that class is never
     added: the widget stays hidden, the native button stays visible, and the
     customer can always still buy. A broken script can't block a sale.
   - Event delegation means it also survives the theme re-rendering the form.
   ============================================================ */
(function () {
  try {
    var MAX_QTY = 20;
    var FREQ_LABELS = [
      '30 day subscription - Save 10%',
      '45 day subscription - Save 10%',
      '60 day subscription - Save 10%'
    ];

    function money(cents) {
      try {
        return '$' + (cents / 100).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      } catch (e) {
        return '$' + (cents / 100).toFixed(2);
      }
    }
    function rootOf(el) { return el && el.closest ? el.closest('.cpo10') : null; }
    function cfg(root, name) { return parseInt(root.getAttribute('data-' + name), 10); }
    function qtyEl(root, opt) { return root.querySelector('#cpo10-qty-' + opt); }
    function getQty(root, opt) {
      var el = qtyEl(root, opt);
      var n = el ? parseInt(el.value, 10) : 1;
      return (isNaN(n) || n < 1) ? 1 : n;
    }
    function refreshPrices(root) {
      var one = cfg(root, 'onetime-price');
      var three = cfg(root, 'threepack-price') || 13990;
      var p1 = root.querySelector('#cpo10-price-onetime');
      if (p1 && !isNaN(one)) p1.textContent = money(one * getQty(root, 'onetime'));

      // 3x pack: struck compare-at (per-product, gross sum of singles) and
      // actual pack price, both scaled by number of packs.
      var tpQty = getQty(root, 'threepack');
      var tpCompare = cfg(root, 'threepack-compare');
      var tpWas = root.querySelector('#cpo10-tp-was');
      var tpNow = root.querySelector('#cpo10-tp-now');
      if (tpWas && !isNaN(tpCompare)) tpWas.textContent = money(tpCompare * tpQty);
      if (tpNow) tpNow.textContent = money(three * tpQty);

      // Subscribe price: original (struck) and discounted (thinner), scaled by qty.
      var disc = cfg(root, 'sub-discount'); // percentage, e.g. 10
      if (isNaN(disc)) disc = 0;
      var was = root.querySelector('#cpo10-was');
      var now = root.querySelector('#cpo10-now');
      if (!isNaN(one)) {
        var subQty = getQty(root, 'subscribe');
        var full = one * subQty;
        var discounted = Math.round(full * (1 - disc / 100));
        if (was) was.textContent = money(full);
        if (now) now.textContent = money(discounted);
      }
    }
    function selectedOption(root) {
      var el = root.querySelector('input[name="cpo10-option"]:checked');
      return el ? el.value : 'onetime';
    }
    function syncSelected(root) {
      var cards = root.querySelectorAll('.cpo10__card');
      for (var i = 0; i < cards.length; i++) {
        var input = cards[i].querySelector('.cpo10__radio');
        cards[i].classList.toggle('cpo10__card--selected', !!(input && input.checked));
      }
      var fw = root.querySelector('#cpo10-freq-wrap');
      if (fw) fw.hidden = (selectedOption(root) !== 'subscribe');
      document.body.classList.toggle('cpo10-hide-express', selectedOption(root) !== 'onetime');
    }
    function currentVariantId(root) {
      var live = document.querySelector('form[action*="/cart/add"] [name="id"]');
      return live && live.value ? parseInt(live.value, 10) : cfg(root, 'fallback-variant');
    }
    // For the 3-pack upsell: pick the 3-pack variant that matches the single
    // variant the customer currently has selected (e.g. roller vs dropper lid).
    // Falls back to the default threepack-variant when there's no mapping.
    function threepackVariantId(root) {
      var def = cfg(root, 'threepack-variant');
      var map = root.getAttribute('data-threepack-map');
      if (!map) return def;
      var selected = currentVariantId(root);
      var pairs = map.split(';');
      for (var i = 0; i < pairs.length; i++) {
        var kv = pairs[i].split(':');
        if (parseInt(kv[0], 10) === selected) {
          var mapped = parseInt(kv[1], 10);
          if (!isNaN(mapped)) return mapped;
        }
      }
      return def;
    }
    function showError(root, msg) {
      var e = root.querySelector('#cpo10-err');
      if (e) { e.textContent = msg; e.hidden = false; }
    }
    function hideError(root) { var e = root.querySelector('#cpo10-err'); if (e) e.hidden = true; }

    function openCartDrawer() {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
      // If Upcart needs a specific event, add it here:
      // document.dispatchEvent(new CustomEvent('upcart:openCart'));
    }

    function addToCart(root) {
      hideError(root);
      var choice = selectedOption(root);
      var qty = getQty(root, choice);
      var btn = root.querySelector('#cpo10-add');
      var freqSel = root.querySelector('#cpo10-frequency');
      var item;

      if (choice === 'threepack') {
        item = { id: threepackVariantId(root), quantity: qty };
      } else if (choice === 'subscribe') {
        var planId = freqSel && freqSel.value ? parseInt(freqSel.value, 10) : null;
        if (!planId) { showError(root, 'Subscription is not available yet. Please choose another option.'); return; }
        item = { id: currentVariantId(root), quantity: qty, selling_plan: planId };
      } else {
        item = { id: currentVariantId(root), quantity: qty };
      }

      if (btn) btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [item] })
      })
        .then(function (r) { if (!r.ok) return r.json().then(function (x) { throw x; }); return r.json(); })
        .then(function () { openCartDrawer(); })
        .catch(function (x) { showError(root, (x && x.description) || 'Sorry, something went wrong. Please try again.'); })
        .then(function () { if (btn) btn.disabled = false; });
    }

    // ---- delegated events: independent of load order / re-renders ----
    document.addEventListener('click', function (ev) {
      try {
        var step = ev.target.closest && ev.target.closest('.cpo10__step');
        if (step) {
          ev.preventDefault();
          var root = rootOf(step);
          if (!root) return;
          var card = step.closest('.cpo10__card');
          var radio = card && card.querySelector('.cpo10__radio');
          if (radio && !radio.checked) { radio.checked = true; syncSelected(root); }
          var opt = step.getAttribute('data-qty');
          var dir = parseInt(step.getAttribute('data-dir'), 10);
          var el = qtyEl(root, opt);
          if (!el) return;
          var next = getQty(root, opt) + dir;
          if (next < 1) next = 1;
          if (next > MAX_QTY) next = MAX_QTY;
          el.value = next;
          refreshPrices(root);
          return;
        }
        var add = ev.target.closest && ev.target.closest('#cpo10-add, .cpo10__btn');
        if (add) {
          var root2 = rootOf(add);
          if (root2) { ev.preventDefault(); addToCart(root2); }
        }
      } catch (e) { /* never let a click handler break the page */ }
    });

    document.addEventListener('change', function (ev) {
      try {
        if (ev.target && ev.target.name === 'cpo10-option') {
          var root = rootOf(ev.target);
          if (root) syncSelected(root);
        }
      } catch (e) { /* ignore */ }
    });

    // ---- one-time setup per instance; reveals the widget only on success ----
    function setup() {
      try {
        var roots = document.querySelectorAll('.cpo10');
        var initialisedAny = false;
        for (var i = 0; i < roots.length; i++) {
          var root = roots[i];
          if (root.dataset.cpoReady) { initialisedAny = true; continue; }
          try {
            var freqSel = root.querySelector('#cpo10-frequency');
            if (freqSel) {
              for (var f = 0; f < freqSel.options.length; f++) {
                if (FREQ_LABELS[f]) freqSel.options[f].textContent = FREQ_LABELS[f];
              }
              // The dropdown sits inside the Subscribe card <label>. A tap on it
              // was ALSO toggling the card's radio via the label's native
              // behaviour, which broke every second tap on mobile. Block that
              // label behaviour for taps that start on the select, while still
              // letting the select open normally.
              var lbl = freqSel.closest('label');
              if (lbl) {
                lbl.addEventListener('click', function (e) {
                  if (e.target && e.target.closest('#cpo10-frequency')) {
                    e.preventDefault();   // stop the label toggling the radio
                    e.stopPropagation();
                  }
                });
              }
              var stop = function (e) { e.stopPropagation(); };
              freqSel.addEventListener('pointerdown', stop);
              freqSel.addEventListener('mousedown', stop);
              freqSel.addEventListener('touchstart', stop, { passive: true });
            }
            refreshPrices(root);
            syncSelected(root);
            root.dataset.cpoReady = '1';
            initialisedAny = true;
          } catch (inner) { /* skip this instance, leave native button visible for it */ }
        }
        // Only now do we hide the native button + reveal the widget.
        if (initialisedAny) document.body.classList.add('cpo10-js-ready');
      } catch (e) { /* if setup fails entirely, native button stays visible */ }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setup);
    } else {
      setup();
    }
    window.addEventListener('load', setup);
    setTimeout(setup, 500);
    setTimeout(setup, 1500); // extra net for late Vue re-render
  } catch (e) {
    /* Total failure: do nothing. The widget stays hidden (CSS default) and the
       native Shopify Add to cart stays visible, so customers can still buy. */
  }
})();